import { render, staticRenderFns } from "./accountLogout.vue?vue&type=template&id=22354858&scoped=true"
import script from "./accountLogout.vue?vue&type=script&lang=js"
export * from "./accountLogout.vue?vue&type=script&lang=js"
import style0 from "./accountLogout.vue?vue&type=style&index=0&id=22354858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22354858",
  null
  
)

export default component.exports